'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { FilterCheckboxGroupSection } from './filter-checkbox-group-section.component';

import { FilterState } from '@/app/(main)/(pages)/busca/[slug]/_types/filter-state.type';
import {
  SearchFilterBookingPreferenceKey,
  searchFilterBookingPreferences,
} from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-booking-preference.type';

const options = searchFilterBookingPreferences.map(({ key, label }) => ({ key, label }));

const testIdValueByKey = new Map(
  searchFilterBookingPreferences.map(({ key, testIdValue }) => [key, testIdValue]),
);

export const bookingPreferenceOptionTestId = (key: SearchFilterBookingPreferenceKey): string =>
  `${DataTestIdEnum.SEARCH_FILTERS_BOOKING_PREFERENCE_OPTION}-${testIdValueByKey.get(key) ?? key}`;

type BookingPreferencesValues = Pick<FilterState, SearchFilterBookingPreferenceKey>;

interface BookingPreferencesFilterSectionProps {
  values: Readonly<BookingPreferencesValues>;
  onChange: (values: Partial<BookingPreferencesValues>) => void;
}

export function BookingPreferencesFilterSection({ values, onChange }: BookingPreferencesFilterSectionProps) {
  const handleChange = (key: SearchFilterBookingPreferenceKey, checked: boolean): void => {
    onChange({ [key]: checked } as Partial<BookingPreferencesValues>);
  };

  return (
    <FilterCheckboxGroupSection
      label="Preferências de agendamento"
      options={options}
      values={values}
      onChange={handleChange}
      testId={DataTestIdEnum.SEARCH_FILTERS_BOOKING_PREFERENCES}
      getOptionTestId={bookingPreferenceOptionTestId}
    />
  );
}
